// TOUR-16 — Training Authoring walkthrough (scenario catalog + publish path).

import type { FireflyTourArtifact } from "../tourTypes";

export const TRAINING_AUTHOR_TOUR_ID = "tour-training-author";

export const TRAINING_AUTHOR_TOUR: FireflyTourArtifact = {
  id: TRAINING_AUTHOR_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "training author tour",
    "create roleplay scenario",
    "author training scenarios",
    "publish roleplay scenario",
    "training authoring walkthrough",
    "how do i add a roleplay scenario",
  ],
  bucketRelevance: ["manager"],
  requiredRoles: ["trainer"],
  steps: [
    {
      id: "nav-training-author",
      target: {
        mode: "trainingAuthor",
        anchorId: "mode-nav-trainingAuthor",
        scrollIntoView: true,
      },
      deferModeNavigation: true,
      skipWhenCurrentMode: "trainingAuthor",
      copy: {
        title: "Open Training Authoring",
        body: "Author roleplay scenarios and org flags here under Manager. Reps practice from Sales → Training → Roleplay. Tap Training Authoring in the sidebar (or bottom bar on mobile).",
      },
      waitForClick: true,
    },
    {
      id: "ta-surface",
      target: { mode: "trainingAuthor", anchorId: "ta-surface", scrollIntoView: true },
      copy: {
        title: "Authoring workspace",
        body: "Tune manufacturer inheritance, pull KB drafts, and edit the trainee catalog. Review queue for rep submissions is not on this surface yet.",
      },
      advanceOn: "next_button",
    },
    {
      id: "catalog-grid",
      target: { mode: "trainingAuthor", anchorId: "ta-catalog-grid", scrollIntoView: true },
      copy: {
        title: "Scenario catalog",
        body: "Workspace tiles are editable org scenarios — Live means published to the Roleplay tab. Manufacturer and platform tiles are read-only on this org.",
      },
      advanceOn: "next_button",
    },
    {
      id: "new-scenario",
      target: { mode: "trainingAuthor", anchorId: "ta-new-scenario", scrollIntoView: true },
      copy: {
        title: "New scenario",
        body: "Tap New scenario to add a draft row and open the editor — or select an existing workspace tile. Fill persona, opener, and rubric fields before publishing.",
      },
      waitForClick: true,
    },
    {
      id: "scenario-editor",
      target: { mode: "trainingAuthor", anchorId: "ta-scenario-editor", scrollIntoView: true },
      copy: {
        title: "Scenario editor",
        body: "Edit labels, scenario key, customer persona, and QA hints. Save changes persists fields; Publish makes the scenario live for reps.",
      },
      advanceOn: "next_button",
    },
    {
      id: "publish-scenario",
      target: { mode: "trainingAuthor", anchorId: "ta-publish-scenario", scrollIntoView: true },
      copy: {
        title: "Publish",
        body: "Publish activates the scenario on the Sales Training Roleplay tab. Unpublish returns it to draft without deleting the row.",
      },
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "trainingAuthor", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Reps consume scenarios from Training mode — not here. Ask Firefly anytime for the Training consumption tour or lead capture from Sales modes.",
      },
      advanceOn: "next_button",
    },
  ],
};
